import styles from './TranscriptionDemo.module.css';

const WAVE_BARS = [
  { height: 20, delay: 0 },
  { height: 35, delay: 0.1 },
  { height: 25, delay: 0.2 },
  { height: 40, delay: 0.3 },
  { height: 30, delay: 0.4 },
  { height: 45, delay: 0.5 },
  { height: 28, delay: 0.6 },
  { height: 38, delay: 0.7 },
  { height: 22, delay: 0.8 },
  { height: 32, delay: 0.9 },
];

const CAPTION_WORDS = [
  'The', 'future', 'of', 'communication', 'is', 'spatial,', 'immersive,', 'and', 'accessible.'
];

export const TranscriptionDemo = () => {
  return (
    <div className={styles.heroVisual}>
      <div className={styles.deviceFrame}>
        <div className={styles.deviceScreen}>
          <div className={styles.transcriptionDemo}>
            <div className={styles.waveform}>
              {WAVE_BARS.map((bar, index) => (
                <div
                  key={index}
                  className={styles.waveBar}
                  style={{
                    height: `${bar.height}px`,
                    animationDelay: `${bar.delay}s`,
                  }}
                />
              ))}
            </div>
            <p className={styles.captionText}>
              {CAPTION_WORDS.map((word, index) => (
                <span
                  key={index}
                  className={styles.word}
                  style={{ animationDelay: `${0.5 + index * 0.2}s` }}
                >
                  {word}{' '}
                </span>
              ))}
              <span className={styles.captionCursor}></span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
